export const axApiPaths = {
  auth: {
    users: {
      token_refresh: '/auth/users/token_refresh',
      token_revoke: '/auth/users/token_revoke',
      authorize: '/auth/users/authorize',
      external_organization: '/auth/users/external_organizations/token_get',
    },
  },
  users: {
    create: '/users/create',
    get: '/users/get',
    put: '/users/put',
    leave: '/users/leave',
    addresses: {
      get: '/users/addresses/get',
      put: '/users/addresses/put',
    },
    password: {
      put: '/users/password/put',
      reset: {
        reset: '/users/password/reset',
        send: '/users/password/reset/send',
      },
    },
    creditCards: {
      get: '/users/credit_cards/get',
      add: '/users/credit_cards/put',
      delete: '/users/credit_cards/delete',
      set_use_continuous_billing: '/users/credit_cards/set_use_continuous_billing',
    },
    gmopg: {
      creditCards: {
        get: '/users/gmopg/credit_cards/get',
        add: '/users/gmopg/credit_cards/put',
        delete: '/users/gmopg/credit_cards/delete',
        set_use_continuous_billing: '/users/gmopg/credit_cards/set_use_continuous_billing',
        transaction: '/users/gmopg/credit_cards/transaction',
        confirm_transaction: '/users/gmopg/credit_cards/confirm_transaction',
      },
    },
    items: {
      reviews: {
        list: '/users/items/reviews/list',
        edit: '/users/items/reviews/edit',
        put: '/items/reviews/put',
        delete: '/users/items/reviews/delete',
      },
    },
    external_organization: {
      put: '/users/external_organizations/put',
      delete: '/users/external_organizations/delete',
    },
    // 会員ステータス
    status: {
      list: '/users/status/list',
    },
    coupon: {
      list: '/users/coupon/list',
    },
    buyable: '/users/buyable',
  },
  orders: {
    get: '/orders/get',
    list: '/orders/list',
    regulars: '/orders/regulars',
    cancel: '/orders/cancel',
    edit: '/orders/edit',
    alreadyBought: '/orders/alreadyBought',
    set: '/orders/builder/information/set',
    create: '/orders/builder/create',
    load: '/orders/builder/cart_load',
    verify: '/orders/builder/verify',
    builder: {
      get: '/orders/builder/get',
      create: '/orders/builder/create',
      load: '/orders/builder/cart_load',
      verify: '/orders/builder/verify',
    },
    delivery: {
      get: '/orders/builder/delivery/get',
      set: '/orders/builder/delivery/set',
    },
    coupon: {
      put: '/orders/builder/coupon/put',
      delete: '/orders/builder/coupon/delete',
    },
    payment: {
      get: '/orders/builder/payment/get',
      set: '/orders/builder/payment/set',
    },
    oplux: '/orders/oplux',
    commit: '/orders/builder/commit',
  },
  clientId: {
    create: '/clients/create',
  },
  items: {
    search: '/items/search',
    get: '/items/get',
    reviews: {
      put: '/items/reviews/put',
      list: '/items/reviews/list',
    },
  },
  category: {
    get: '/utility/categories/get',
    trees: '/utility/category_trees/get',
  },
  variation: {
    get: '/utility/variations/get',
  },
  notify: {
    arrival_items: {
      put: '/notify/arrival_items/put',
      get: '/notify/arrival_items/get',
      delete: '/notify/arrival_items/delete',
    },
  },
  presentation: {
    viewed_items: {
      get: '/presentation/viewed_items/get',
      put: '/presentation/viewed_items/put',
    },
  },
  carts: {
    add: '/carts/add',
    remove: '/carts/remove',
    put: '/carts/put',
    get: '/carts/get',
    clear: '/carts/delete',
    display: {
      get: '/carts/display/get',
    },
  },

  point: {
    balance: '/users/point/balance/get',
    list: '/users/point/history/get',
  },
  coupon: {
    list: '/coupons/list',
    detail: '/coupons/get',
    issue: '/coupons/issue',
    issued_list: '/coupons/issued/list',
  },
}
